import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

interface UseDeleteAppointmentOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useDeleteAppointment = (options?: UseDeleteAppointmentOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => apiClient.delete(`appointments/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['appointments'] });
      // Deleting a visit can give its package service back.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.clientPackages.all(),
      });
      toast.success('Appointment deleted');
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to delete appointment');
      options?.onError?.(error);
    },
  });

  return {
    deleteAppointment: mutation.mutate,
    deleteAppointmentAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
};
